export default __webpack_public_path__ + "077d23a5f000a95cda5a633bd6a606ef.png";